import { render, staticRenderFns } from "./MemoSync.vue?vue&type=template&id=42ad3b9c&scoped=true&"
import script from "./MemoSync.vue?vue&type=script&lang=js&"
export * from "./MemoSync.vue?vue&type=script&lang=js&"
import style0 from "./MemoSync.vue?vue&type=style&index=0&id=42ad3b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad3b9c",
  null
  
)

export default component.exports